import { string, object } from "yup";

export const forgetPasswordValidationSchema = object().shape({
    email: string().email("Email is not valid").required("Email is required"),
});
